"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_69_0_0 = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
/**
 * Migrate to 69.0.0
 *
 * change Unit of Torsionswinkel from °_m to deg_m
 *
 */
const migration_69_0_0 = (json) => {
    if (json.Leitungen) {
        json.Leitungen.forEach((leitungJson) => {
            var _a, _b;
            if (((_a = leitungJson.Torsionswinkel) === null || _a === void 0 ? void 0 : _a.Value) && ((_b = leitungJson.Torsionswinkel) === null || _b === void 0 ? void 0 : _b.Unit) === '°_m') {
                leitungJson.Torsionswinkel = { Unit: echain_shared_quantities_1.AnglePerLengthUnits.deg_m, Value: leitungJson.Torsionswinkel.Value };
            }
        });
    }
    return json;
};
exports.migration_69_0_0 = migration_69_0_0;
//# sourceMappingURL=migration_69_0_0.js.map